export const COOKIE_DOMAIN = ["sta", "production"].includes(import.meta.env.MODE)
  ? window.location.hostname.split(".").slice(-2).join(".")
  : undefined;
